import { styled } from '@mui/material/styles';
import MuiFormControlLabel from '@mui/material/FormControlLabel';
import MuiFormControl from '@mui/material/FormControl';
import MuiRadio from '@mui/material/Radio';

export const FormControl = styled(MuiFormControl)(() => ({
  width: '100%'
}));

export const Radio = styled(MuiRadio)(({ theme }) => ({
  padding: '12px',
  color: theme.palette.neutrals.beige4,
  '&.Mui-checked': {
    color: theme.palette.brand.darkGreen
  }
}));

export const FormControlLabel = styled(MuiFormControlLabel)(({ theme }) => ({
  backgroundColor: 'transparent',
  paddingLeft: '8px',
  paddingRight: '24px',
  width: '100%',
  margin: '0',
  borderRadius: '12px',
  border: `1px solid ${theme.palette.neutrals.beige4}`,
  alignItems: 'center',
  '&:has(.Mui-checked)': {
    border: `1px solid ${theme.palette.brand.darkGreen}`,
    backgroundColor: theme.palette.neutrals.beige2
  },
  '& .MuiFormControlLabel-label': {
    flex: 1,
    paddingTop: '17px',
    paddingBottom: '17px'
  }
}));
